import { useEffect, useRef } from 'react';

import { observer } from 'mobx-react-lite';
import styled, { keyframes } from 'styled-components';

import { getElementHeight, getVisibleWidth } from '@utils/browser';
import { transitionSlow } from '@utils/transitions';

import { CARD_PADDING, CARD_RADIUS, CONTENT_MAX_WIDTH, HEADER_SHADOW } from '../styles/constants';

function CompanyOpeningsHeader({ mainRef, bannerRef, children, id }) {
  const instanceRef = useRef();

  useEffect(() => {
    function handleScroll() {
      const main = mainRef.current;
      const banner = bannerRef.current;
      const width = getVisibleWidth();
      if (width < 600) {
        return;
      }

      if (instanceRef.current && window.pageYOffset > getElementHeight(banner)) {
        instanceRef.current.classList.add('sticky');
        if (main && main.style) {
          main.style.marginTop = '72px';
        }
      } else {
        instanceRef.current.classList.remove('sticky');
        if (main && main.style) {
          main.style.marginTop = '0px';
        }
      }
    }

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [bannerRef, mainRef]);

  return (
    <Wrapper id={id} ref={instanceRef}>
      {children}
    </Wrapper>
  );
}

export default observer(CompanyOpeningsHeader);

// The `slow` tier. transitionSlow() covers the transition; the keyframe
// animation needs a bare duration.
const SLIDE_DURATION = '300ms';

const slideDown = keyframes`
  from {
    transform: translateY(-16px);
  }
  to {
    transform: translateY(0);
  }
`;

const Wrapper = styled.div`
  color: ${(p) => p.theme.primaryColor};
  background-color: ${(p) => p.theme.white};
  border-radius: ${CARD_RADIUS} ${CARD_RADIUS} 0 0;
  min-height: 64px;
  padding: ${CARD_PADDING};
  transition: ${transitionSlow('box-shadow', 'border-radius')};
  width: 100%;
  display: flex;
  z-index: 10;
  align-items: center;

  > div {
    margin: 0 auto;
    width: 100%;
    max-width: ${CONTENT_MAX_WIDTH};
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  @media (max-width: 600px) {
    button {
      display: none;
    }
  }

  &.sticky {
    border-radius: 0;
    box-shadow: ${HEADER_SHADOW};
    padding: 16px 24px;

    @media (min-width: 600px) {
      position: fixed;
      width: 100%;
      top: 0px;
      left: 0;
      animation: ${slideDown} ${SLIDE_DURATION} ease-in-out;
    }
  }
  box-sizing: border-box;
`;
